import {Component, OnInit, Input} from '@angular/core';
import {JsonApiError} from "angular2-jsonapi";

@Component({
  selector: 'app-server-errors',
  templateUrl: './server-errors.component.html',
  styleUrls: ['./server-errors.component.css']
})
export class ServerErrorsComponent implements OnInit {

  constructor() { }

  @Input() errors: JsonApiError[] = [];

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/server-errors/server-errors.component.ts